import { BOOK_BUSINESS_APPOINTMENT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface RequestResponse {
    success: boolean;
    data: {
        appointment: Appointment;
    };
    error?: string;
}
export interface Appointment {
    date: string;
    doctor_oid: string;
    aid: string;
    patient_uuid: string;
    patient_oid: string;
    clinic_id: string;
    channel: string;
    onsched_id: string;
    status: string;
    start_time: string;
    end_time: string;
    created_at: string;
    amount: number;
    service: string;
}

export type RequestBodyPayload = {
    clinic_id: string;
    patient: { oid: string };
    tags: [];
    start_time: string;
    end_time: string;
    action: 'BK';
    channel: 'Doctor';
    mode: 'in-clinic';
};

export interface RequestBody {
    payload: RequestBodyPayload;
}
export interface Payload {
    isoDateTime: string;
    profile: Profile;
    channel: string;
}
export interface Profile {
    oid: string;
}

export default (payload: RequestBodyPayload & { docId: string }): Promise<RequestResponse> => {
    const request: RequestBody = {
        payload: payload,
    };
    return fetchWithRefresh(BOOK_BUSINESS_APPOINTMENT(payload.docId), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        return res.json();
    });
};
